import { render, staticRenderFns } from "./StepContentDropdowns.vue?vue&type=template&id=5ddc53b0"
import script from "./StepContentDropdowns.vue?vue&type=script&lang=js"
export * from "./StepContentDropdowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports